import trimEnd from 'lodash-es/trimEnd';

export interface AgWidgetConfigData {
  /**
   * Base url of the AG API that the AG Bar component will fetch/save it's data
   *
   * EG: 'https://qa-agapi-rel.redmz.mrisoftware.com'
   */
  baseApiUrl: string;
  trainingAcademyUrl: string;
  showDetailedErrorMessages: boolean;
  useCdn: boolean;
  cdnUrl: string;
  /**
   * Hint as to whether fetch requests from AG API should be included in app insights or no
   *
   * Note: this setting value will have no affect unless you have added app insights to your angular app
   * AND you use this setting to instruct app insights to track AG API requests
   *
   * @default false
   */
  enableAppInsights?: boolean;
}

const defaults: AgWidgetConfigData = {
  baseApiUrl: '',
  trainingAcademyUrl: '',
  enableAppInsights: false,
  showDetailedErrorMessages: false,
  useCdn: false,
  cdnUrl: ''
};

// eslint-disable-next-line @typescript-eslint/no-empty-object-type, @typescript-eslint/no-empty-interface
export interface AgWidgetConfig extends AgWidgetConfigData {}

export class AgWidgetConfig {
  get apiDomain() {
    return this.baseApiUrl ? new URL(this.baseApiUrl).hostname : 'localhost';
  }

  // private get IsDeveloperServer() {
  //   return this.apiDomain.includes('local');
  // }

  constructor(json?: AgWidgetConfigData) {
    json = json ?? defaults;
    const baseApiUrl = trimEnd(json.baseApiUrl, '/').trim();
    const cdnUrl = json.cdnUrl.trim();
    Object.assign(this, defaults, json, { baseApiUrl, cdnUrl });
  }
}
